import { useIsMerchant } from "./use-is-merchant";
import { usePlatform } from "./use-platform";

// Shop Now hands off to the live Shopify storefront to browse products, which
// only works when genuinely embedded there. Outside that context (baback-office
// /o preview, admin retractation portal), the merchant picks the articles from
// the catalog instead. Reserved to merchants previewing the widget, never for
// real end customers, and never on the shopify platform where Shop Now works.
export function useCatalogSearchActive(): boolean {
  const platform = usePlatform();
  const isMerchant = useIsMerchant();
  return platform === "baback-office" && isMerchant;
}
